export const SET_TUTORIAL_ACTIVE = 'tutorial/SET_TUTORIAL_ACTIVE';
export const SET_TRAINING_TIPS_ACTIVE = 'tutorial/SET_TRAINING_TIPS_ACTIVE';
